import * as DropdownMenu from '@wandb/weave/components/DropdownMenu';
import {Icon} from '@wandb/weave/components/Icon';
import React from 'react';

import {DD_PRIVACY_ALLOW} from '../../../util/datadog/privacy';

export const PanelCopyLinkMenuItem = ({onSelect}: {onSelect: () => void}) => {
  return (
    <DropdownMenu.Item
      data-dd-action-name="Copy panel link"
      data-dd-privacy={DD_PRIVACY_ALLOW}
      onSelect={onSelect}>
      <Icon name="link-alt" />
      Copy panel URL
    </DropdownMenu.Item>
  );
};
